import React from 'react'
import { connect } from 'react-redux'
import './header.css'
import conChange from '../common/common.js'
import {getVipUser} from '../../redux/user.redux'

import {getUnReadNum} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import { Link} from "react-router-dom"
import axios from 'axios'
import ToastBar from  '../toast/toast.js'
@withRouter
@conChange
@connect(
  state=>state.chatuser,
  {getUnReadNum}
)
class HeaderBar extends React.Component{
	
	constructor(props){
		super(props)
		
		this.state={
			index:'',
			showLogin:false,
			headermndex:0,
			visible:false,
      		iTop:'',
      		visibleText:'',
			
			navList:[
			{
				title:'首页',
				esc:'INDEX',
				active:'',
				mUrl:'/index',
				listUrl:['/index'],
				childList:{
					text:[],
					path:[]
				}
				
			},

			{
				title:'服务特权',
				esc:'SERVICE',
				active:'',
				listUrl:[''],
				mUrl:'3',
				childList:{

					text:['大客户经理','V+服务'],
					path:[
						'/templates/privilege.html',
						'/v/index.html']
				}
			},
			{
				title:'游戏特权',
				esc:'GAME',
				active:'',
				listUrl:[''],
				childList:{

					text:['G福利','传奇悦享会','积分商城','游戏礼包'],
					path:[
						'https://vip.sdo.com/yx/club/index.html',
						'http://xinyue.qq.com/act/pc/a20170812rxgc/home.shtml',
						'http://jf.sdo.com',
						'/new-game'
						]
				}
			},
			{
				title:'回归特权',
				esc:'RETURN',
				active:'',
				mUrl:'1',
				listUrl:[''],
				childList:{

					text:['敬请期待'],
					path:['','']
				}
			},
			{
				title:'福利商城',
				esc:'SHOPPING',
				active:'',
				mUrl:'4',
				listUrl:['https://qu.sdo.com/game/3'],
				childList:{
					text:[],
					path:[]
					
				}
			},/*
			{
				title:'游戏娱乐',
				esc:'AMUSEMENT',
				active:'',
				mUrl:'1',
				listUrl:[''],
				childList:{

					text:['猫练师','心享直播'],
					path:['http://mao.sdo.com','http://mao.sdo.com/live/index']
				}
			},*/
			{
				title:'个人中心',
				esc:'PERSONAL CENTER',
				active:'',
				mUrl:'/my-member',
				listUrl:['/my-member','/my-welfare','/my-message'],
				childList:{

					text:[],
					path:[]
			 }
			}

		]
		

		
		
		}
		
		//const MyOrigin = window.location.origin
		this.MyOrigin = window.location.origin
		this.pathname = this.MyOrigin +''+ this.props.location.pathname
		
	}

	componentDidMount(){
		
		this.props.getUnReadNum()
		
		document.title = '心享俱乐部—用心服务，感动用户'
		document.getElementById('meta1').setAttribute('content','心享俱乐部，心享俱乐部官网，V+，心享俱乐部游戏特权礼包') 
  		document.getElementById('meta2').setAttribute('content','心享俱乐部是专为游戏玩家提供的VIP会员服务平台。为每一位VIP玩家提供私人游戏顾问，提供更全面、互动以及个性的特权服务内容。心享俱乐部将用心为每一位游戏玩家服务，感动用户。') 
		this.setState({
			showLogin: this.props.showLogin
		})
		const pathname = this.props.location.pathname
		
		for(let i=0;i<this.state.navList.length;i++){
			for(let j=0;j<this.state.navList[i].listUrl.length;j++){
				if(this.state.navList[i].listUrl&&this.state.navList[i].listUrl[j]===pathname){
					this.state.navList[i].active = 'active'
				}
			}
			
		}
		this.setState({
			navList:this.state.navList
		})

	}
	componentWillReceiveProps(props) {
		
		this.setState({
			showLogin: this.props.showLogin
			
		})

	}
	
	handleLogin(){		
		const ipath = {
			 pathname:'/login',
 			 query:window.location.href
		}
		this.props.history.push(ipath)
		/*
		const _this = this
		axios.get('/fapi/getLoginURL?redirect_url='+window.location.href)
	      .then(res=>{
	       	if(res.data.return_code==0){
				
	       		window.location.href = res.data.redirect_url
	       		
	       		this.setState({
					showLogin:true
				})
			      
	       	}
	     
	    })
	    */
		
	}
	handleLogout(){
	
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.MyOrigin)

	}
	
	handleShowNav(myIdx){
		console.log('1',myIdx)
		this.setState({
			visible:false
		},()=>{
			this.setState({
				
				index:myIdx
				
			})
		})

		return false			
	}
	closeBack(data){
		if(data==1){
			this.setState({
				visible:false
				
			})
		}
	}
	handleHref(murl,i,listUrl){
		
		if(murl=='4'){
			
			this.setState({
				visible:true,
				visibleText:'添加心享plus小程序  享专属会员超低折扣'
			})
			
			
		}else if(murl=='3'){
			
			this.setState({
				visible:true,
				visibleText:'添加心享plus小程序  享1对1专属服务'
			})
			
			
		}else{
			if(this.props.showLogin&&murl&&murl!=1||murl=='/index'){
				
				this.props.history.push(murl)
				
				
			}else if(!this.props.showLogin&&murl&&murl!=1){
				const ipath = {
					 pathname:'/login',
		 			 query:murl
				}
				
				this.props.history.push(ipath)
			}
		}
		
		
		return false		
	}
	handleChange(){
			
		this.setState({
			index:-1			
		})
					
	}
	render(){
		
		
		const userlist= this.props.userlist?this.props.userlist:''
		
		const oUl = '<ul><li>{userlist.inputUserId}</li></ul>'
		
		var  userLevel = this.props.userlist.gradeInfo?this.props.userlist.gradeInfo.vipGrade:'login-level-1'
		
		if(userLevel<=1){
			userLevel= 'user-level-1'
		}
		 if(userLevel<=4&&userLevel>1){
			userLevel= 'user-level-2'
		}
		 if(userLevel>4&&userLevel<=7){
			userLevel= 'user-level-3'
		}
		if(userLevel>=8){
			userLevel= 'user-level-4'
		}
		
		
		return (
			
			<div className="headerBar-box">
				
				<div className="header-banner">
					
						<div style={userlist.displayAccount&&this.props.showLogin?{"display":"block"}:{"display":"none"}}>
						
			          <ul>
						<li className={userLevel}>{userlist.displayAccount}</li>
						<li className="integral">{userlist.scoreinfo?userlist.scoreinfo.score:null}</li>
						<li className={this.props.unRead==0?'message-icon':'message-ac-icon'}><Link to="/my-message">( {this.props.unRead} )</Link></li>
					  </ul>																	
						<button onClick={this.handleLogout.bind(this)}>注销</button>
					</div>
					
					
					<div className="login-btn-box">
						<button 
							className="login-btn" 
							onClick={this.handleLogin.bind(this)} 
							style={this.props.showLogin?{display:'none'}:{display:'block'}}						
						>登录</button>
						
					
					</div>
				</div>
				<header>
					<span className="logo"></span>
					<nav>
						
						{this.state.navList.map((item,i)=>(
							<div 
								key={i} 
								className={i!==0&i!==5&i!==0&i!==4&&i!==1&i==this.state.index?'navActive':''}																 
								onMouseLeave={()=>this.handleChange()}
								
							>					
								<div 
									onMouseEnter={()=>this.handleShowNav(i)}
									className="item-list"
									onClick={item.mUrl?()=>this.handleHref(item.mUrl,i,item.listUrl):null}
									>
									
									<h6  className={item.active}>{item.title}</h6>
									<span>{item.esc}</span>
								
									
								</div>
								<ul  style={i!==0&&i!==5&&i!==4&&i!==1&this.state.index!=-1&i==this.state.index?{display:"block"}:{display:'none'}}>
								{
									item.childList.text.map((item2,n)=>(
										i===3?<li key={n}>{item.childList.text[n]}</li>:
										<li key={n}><a href={item.childList.path[n]} target="_blank">{item.childList.text[n]}</a></li>
									))
										
								}	
			
								</ul>

					 		</div>

						))}
					</nav>
				</header>
				{
					this.state.visible&&<ToastBar 
						visible={this.state.visible}  
						isOkShow ={false}
						iTop={this.state.iTop} 
						title="温馨提示"
						ToastBarClose={()=>this.closeBack()}
					>
						<div className="plus-code">
							<span className="code-img"></span>
							<span className="code-text">{this.state.visibleText}</span>
						</div>
					</ToastBar>
				}

			</div>
			)
		
	}
}

export default HeaderBar


// WEBPACK FOOTER //
// ./src/component/header/header.js